import React, { useState, useEffect } from 'react';
import { motion } from 'motion/react';

const CountdownTimer = ({ targetDate }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = +targetDate - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        dias: Math.floor(difference / (1000 * 60 * 60 * 24)),
        horas: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutos: Math.floor((difference / 1000 / 60) % 60),
        segundos: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const timeBlocks = [
    { label: 'Dias', value: timeLeft.dias || 0 },
    { label: 'Horas', value: timeLeft.horas || 0 },
    { label: 'Minutos', value: timeLeft.minutos || 0 },
    { label: 'Segundos', value: timeLeft.segundos || 0 }
  ];

  return (
    <div className="flex flex-wrap justify-center gap-3 md:gap-6">
      {timeBlocks.map((block, index) => (
        <motion.div
          key={block.label}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            type: 'spring',
            damping: 80,
            stiffness: 400,
            delay: 0.3 + index * 0.1
          }}
          className="flex flex-col items-center"
        >
          <motion.div
            className="relative w-20 h-20 md:w-28 md:h-28 rounded-2xl bg-white/90 backdrop-blur-sm shadow-lg border border-white/50 flex items-center justify-center overflow-hidden"
            whileHover={{ scale: 1.05 }}
            transition={{ type: 'spring', stiffness: 400, damping: 25 }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-[#D98A8C]/10 via-[#E1C567]/10 to-[#DFB573]/10" />
            <motion.span
              key={block.value}
              initial={{ opacity: 0, scale: 0.5 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ type: 'spring', stiffness: 500, damping: 30 }}
              className="relative text-3xl md:text-5xl font-semibold text-[#0A0A0A]"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              {String(block.value).padStart(2, '0')}
            </motion.span>
          </motion.div>
          <span
            className="mt-2 text-sm md:text-base text-[#3C3B3D] font-medium"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            {block.label}
          </span>
        </motion.div>
      ))}
    </div>
  );
};

export default CountdownTimer;
